import React, { useEffect, useState } from 'react'
import { getSiteInfo, userSubscribe } from '../../Services/SiteInfoServices'
import toast from 'react-hot-toast';
import { postStrip } from '../../Services/stripServices';

const useSiteInfo = () => {

    const [isLoading, setIsLoading] = useState();
    const [siteInfo, setSiteInfo] = useState(null)


    const [clientSecret, setClientSecret] = useState(null);


    const handleSubmit = async () => {
        // e.preventDefault();
        // setIsLoading(true);

        let response = await postStrip({ total_amount: siteInfo?.subscriptionFees * activeyears?.length });
        if (response.statusCode === 200) {
            setClientSecret(response?.response?.data?.client_secret)
            console.log("strip response ", response)

        } else if (response.statusCode === 401) {
            // toast.error(response.errors);
        } else {

            // Object.values(response.errors).forEach(error => {
            //     toast.error(error);
            // });
        }

        // setIsLoading(false);
    };

    useEffect(() => {
        handleSubmit();
    }, []);

    const months = [];
    const currentDate = new Date();


    


    for (let i = 0; i < 12; i++) {
        const newDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + i, 1);
        const monthName = newDate.toLocaleString('default', { month: 'short' });
        const year = newDate.getFullYear();
        const currentMonth = monthName.split(' ');
        months.push({ name: `${currentMonth[0]} ${year}` });
        // console.log("months", currentMonth)
    }

    const [activeyears, setActiveyears] = useState([months[0]?.name])


    const handleMonths = (index) => {
        setActiveyears(prev => {
            const newIndex = months.findIndex(m => m.name === index);

            if (prev.length === 0) {
                return [index]; // Pehla month select ho to bas usko add kar do
            }

            const selectedIndexes = prev.map(item => months.findIndex(m => m.name === item)).sort((a, b) => a - b);

            const firstSelected = selectedIndexes[0]; // Pehla selected month ka index
            const lastSelected = selectedIndexes[selectedIndexes.length - 1]; // Akhri selected month ka index

            if (newIndex < firstSelected) {
                // Agar newIndex pehle wale se chhota hai, to newIndex se lastSelected tak sab select karo
                return months.slice(newIndex, lastSelected + 1).map(m => m.name);
            } else {
                // Agar newIndex bada hai, to firstSelected se newIndex tak sab select karo
                return months.slice(firstSelected, newIndex + 1).map(m => m.name);
            }
        });
    };

    const handleSiteInfo = async () => {
        setIsLoading(true)
        let response = await getSiteInfo()
        if (response.statusCode === 200) {
            setSiteInfo(response?.response?.data)
            setIsLoading(false)
        } else if (response.statusCode === 401) {
            toast?.error(response?.errors)
            setIsLoading(false)
        } else {
            for (const [key, value] of Object.entries(response?.errors)) {
                toast?.error(value)
            }
            setIsLoading(false)
        }
        setIsLoading(false)
    }

    const handleUserSubscribe = async () => {
        let body = {
            price: siteInfo?.subscriptionFees * activeyears?.length,
            payment_gateway: 'stripe',
            payment_status: 'completed',
            data: activeyears,
            transaction_id: 12345
        }

        let response = await userSubscribe(body)
        if (response.statusCode === 200) {
            toast?.success(response?.message)
            // setIsLoading(false)
        } else if (response.statusCode === 401) {
            toast?.error(response?.errors)
            // setIsLoading(false)
        } else {
            for (const [key, value] of Object.entries(response?.errors)) {
                toast?.error(value)
            }
            // setIsLoading(false)
        }
        // setIsLoading(false)
    }

    useEffect(() => { handleSiteInfo(); }, [])


    return {
        handleSiteInfo,
        siteInfo,
        months,
        handleSubmit,
        activeyears,
        handleMonths,
        handleUserSubscribe
    }
}

export default useSiteInfo